(() => {
    document.querySelectorAll('[data-ymm]').forEach((root) => {
        const BASE = '/tools/ymm';
        const STORE_PREFIX = 'ymmSel:';
        const STORE_TTL = 30 * 24 * 60 * 60 * 1000;

        const state = { year: null, makeId: null, modelId: null, tags: [] };
        const cache = new Map();
        let yearsLoaded = false;

        const $ = (s) => root.querySelector(s);
        const keys = ['year', 'make', 'model'];
        const pick = (attr) =>
            Object.fromEntries(keys.map((k) => [k, $(`[data-ymm-${attr}="${k}"]`)]));

        const el = {
            trigger: pick('trigger'),
            label: pick('label'),
            menu: pick('menu'),
            search: $('[data-ymm-search]'),
            reset: $('[data-ymm-reset]'),
        };

        const now = () => Date.now();
        const jParse = (raw) => {
            try { return JSON.parse(raw); } catch { return null; }
        };
        const valid = (o) => !!(o && typeof o.ts === 'number' && (now() - o.ts) <= STORE_TTL);
        const storeGet = (k) => {
            try { return jParse(sessionStorage.getItem(k) || localStorage.getItem(k)); } catch { return null; }
        };
        const storeSet = (k, o) => {
            try {
                o.ts = now();
                const raw = JSON.stringify(o);
                localStorage.setItem(k, raw);
                sessionStorage.setItem(k, raw);
            } catch {}
        };
        const storeRemove = (k) => {
            try { localStorage.removeItem(k); sessionStorage.removeItem(k); } catch {}
        };

        const normLabel = (txt) => {
            const t = (txt || '').trim();
            if (!t) return '';
            if (/^select\s+/i.test(t)) return '';
            return t;
        };

        const closeAll = () => Object.values(el.menu).forEach((m) => m && m.classList.remove('is-open'));
        const toggleMenu = (k) => {
            const m = el.menu[k];
            if (!m) return;
            const open = m.classList.contains('is-open');
            closeAll();
            if (!open) m.classList.add('is-open');
        };
        const disable = (k) => el.trigger[k] && el.trigger[k].classList.add('is-disabled');
        const enable = (k) => el.trigger[k] && el.trigger[k].classList.remove('is-disabled');

        const api = async (path) => {
            const url = `${BASE}${path}`;
            if (cache.has(url)) return cache.get(url);
            const p = fetch(url, { headers: { accept: 'application/json' } }).then(async (r) => {
                if (!r.ok) throw new Error(`API ${r.status}: ${url}`);
                const j = await r.json();
                return j && typeof j === 'object' && 'data' in j ? j.data : j;
            });
            cache.set(url, p);
            return p;
        };

        const renderMenu = (k, items, onPick) => {
            const m = el.menu[k];
            if (!m) return;
            m.innerHTML = '';

            if (!items || !items.length) {
                m.innerHTML = `<div class="ymm__empty">No options</div>`;
                return;
            }

            const frag = document.createDocumentFragment();
            items.forEach((it) => {
                const d = document.createElement('div');
                d.className = 'ymm__option';
                d.textContent = it.label;
                d.addEventListener('click', async (e) => {
                    e.stopPropagation();
                    await onPick(it);
                    closeAll();
                });
                frag.appendChild(d);
            });
            m.appendChild(frag);
        };

        const setLabel = (k, v) => { if (el.label[k]) el.label[k].textContent = v; };
        const setMenuHTML = (k, html) => { if (el.menu[k]) el.menu[k].innerHTML = html; };
        const setSearchEnabled = (on) => {
            if (!el.search) return;
            el.search.classList.toggle('is-disabled', !on);
        };

        const resetAfterYear = () => {
            state.makeId = null;
            state.modelId = null;
            state.tags = [];
            setLabel('make', 'Select Make');
            setLabel('model', 'Select Model');
            setMenuHTML('make', '');
            setMenuHTML('model', '');
            disable('make');
            disable('model');
            setSearchEnabled(false);
        };

        const resetAfterMake = () => {
            state.modelId = null;
            state.tags = [];
            setLabel('model', 'Select Model');
            setMenuHTML('model', '');
            disable('model');
            setSearchEnabled(false);
        };

        const fullResetUIAndState = () => {
            closeAll();
            state.year = null;
            resetAfterYear();
            setLabel('year', 'Select Year');
            setMenuHTML('year', '');
            setSearchEnabled(false);
        };

        const saveLast = () => {
            const payload = {
                year: state.year || '',
                makeId: state.makeId || '',
                modelId: state.modelId || '',
                make: normLabel(el.label.make?.textContent),
                model: normLabel(el.label.model?.textContent),
            };
            if (!payload.year) return;
            storeSet(STORE_PREFIX + 'last', payload);
            try { window.dispatchEvent(new CustomEvent('ymm:update', { detail: payload })); } catch {}
        };

        const clearLast = () => storeRemove(STORE_PREFIX + 'last');

        const fetchModels = async () => {
            try {
                return await api(`/${encodeURIComponent(state.year)}/${encodeURIComponent(state.makeId)}/models?sort=asc`);
            } catch {
                return [];
            }
        };

        const fetchTags = async () => {
            try {
                return await api(
                    `/${encodeURIComponent(state.year)}/${encodeURIComponent(state.makeId)}/${encodeURIComponent(state.modelId)}/tags`
                );
            } catch {
                return [];
            }
        };

        const goSearch = () => {
            if (!state.tags.length) return;
            // const q = state.tags.map((t) => `tag:${t}`).join(' OR ');

            const quoteIfNeeded = (tag) =>
    /\s/.test(tag)
        ? `"${tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`
        : tag;

const q = state.tags
    .map((tag) => `tag:${quoteIfNeeded(tag)}`)
    .join(' OR ');

            const params = new URLSearchParams({ q, type: 'product', ymm_tags: state.tags.join(',') });
            window.location.href = `/search?${params.toString()}`;
        };

        const onMake = async (o) => {
            state.makeId = String(o.value);
            setLabel('make', o.label);
            resetAfterMake();

            const models = await fetchModels();
            renderMenu('model', (models || []).map((m) => ({ label: m.name, value: m.id })), onModel);

            enable('model');
            toggleMenu('model');
            saveLast();
        };

        const onModel = async (o) => {
            state.modelId = String(o.value);
            setLabel('model', o.label);

            const tags = await fetchTags();
            state.tags = Array.isArray(tags) ? tags.map((t) => t?.name).filter(Boolean) : [];
            setSearchEnabled(state.tags.length > 0);
            saveLast();
        };

        const restoreLast = async () => {
            const last = storeGet(STORE_PREFIX + 'last');
            if (!valid(last) || !last.year) return;

            state.year = String(last.year);
            setLabel('year', String(last.year));
            resetAfterYear();

            let makes = [];
            try { makes = await api(`/${encodeURIComponent(state.year)}/makes?sort=asc`); } catch { makes = []; }

            renderMenu('make', (makes || []).map((m) => ({ label: m.name, value: m.id })), onMake);
            enable('make');

            if (!last.makeId) {
                if (last.make) setLabel('make', last.make);
                return;
            }

            state.makeId = String(last.makeId);
            const foundMake = Array.isArray(makes) ? makes.find((m) => String(m.id) === String(state.makeId)) : null;
            setLabel('make', foundMake?.name || last.make || 'Select Make');

            resetAfterMake();

            const models = await fetchModels();
            renderMenu('model', (models || []).map((m) => ({ label: m.name, value: m.id })), onModel);
            enable('model');

            if (!last.modelId) {
                if (last.model) setLabel('model', last.model);
                return;
            }

            state.modelId = String(last.modelId);
            const foundModel = Array.isArray(models) ? models.find((m) => String(m.id) === String(state.modelId)) : null;
            setLabel('model', foundModel?.name || last.model || 'Select Model');

            const tags = await fetchTags();
            state.tags = Array.isArray(tags) ? tags.map((t) => t?.name).filter(Boolean) : [];
            setSearchEnabled(state.tags.length > 0);
        };

        el.trigger.year?.addEventListener('click', async (e) => {
            e.stopPropagation();

            if (!yearsLoaded) {
                let years = [];
                try { years = await api('/years?sort=desc'); } catch { years = []; }

                renderMenu(
                    'year',
                    (years || []).map((y) => ({ label: String(y), value: String(y) })),
                    async (o) => {
                        state.year = String(o.value);
                        setLabel('year', o.label);

                        resetAfterYear();

                        let makes = [];
                        try { makes = await api(`/${encodeURIComponent(state.year)}/makes?sort=asc`); } catch { makes = []; }

                        renderMenu('make', (makes || []).map((m) => ({ label: m.name, value: m.id })), onMake);
                        enable('make');
                        toggleMenu('make');
                        saveLast();
                    }
                );

                yearsLoaded = true;
            }

            toggleMenu('year');
        });

        el.trigger.make?.addEventListener('click', (e) => {
            e.stopPropagation();
            if (el.trigger.make.classList.contains('is-disabled')) return;
            toggleMenu('make');
        });

        el.trigger.model?.addEventListener('click', (e) => {
            e.stopPropagation();
            if (el.trigger.model.classList.contains('is-disabled')) return;
            toggleMenu('model');
        });

        el.search?.addEventListener('click', (e) => {
            e.stopPropagation();
            if (el.search.classList.contains('is-disabled')) return;
            saveLast();
            goSearch();
        });

        el.reset?.addEventListener('click', (e) => {
            e.stopPropagation();
            clearLast();
            yearsLoaded = false;
            cache.clear();
            fullResetUIAndState();
            try { window.dispatchEvent(new CustomEvent('ymm:reset')); } catch {}
        });

        document.addEventListener('click', (e) => {
            if (!root.contains(e.target)) closeAll();
        });

        window.addEventListener('pageshow', restoreLast);

        fullResetUIAndState();
        restoreLast();
    });
})();
